import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalOverlayProps,
  ModalProps,
  ModalBodyProps,
} from '@telescope/cassini-ui';
import { useScroll } from 'hooks';
import React, { useEffect } from 'react';
import { isIframed } from 'utils';

interface ContentModalProps extends ModalProps {
  bodyProps?: ModalBodyProps;
  overlayProps?: ModalOverlayProps;
}

export const ContentModal = ({ bodyProps, overlayProps, children, ...props }: ContentModalProps) => {
  const { scrollToTop } = useScroll();

  useEffect(() => {
    if (isIframed() && props.isOpen) {
      scrollToTop();
    }
  }, [scrollToTop, props.isOpen]);

  return (
    <Modal {...props} blockScrollOnMount={!isIframed()}>
      <ModalOverlay {...overlayProps} />
      <ModalContent>
        <ModalCloseButton size="lg" />
        <ModalBody p={[7, 10]} bg="surface" color="on-surface" {...bodyProps}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
